<template>
  <div id="postdetails">
    <section class="is-fullheight">
      <Navigation></Navigation>
      <div class="has-margin-top-80 has-margin-bottom-40">
        <div class="container">
          
          <div class="columns is-centered">
            <div class="column is-6">

              <div class="card-content">
                <h3 class="has-text-centered">{{ $t('postedit.edit') }}</h3>
                <!--<div>editContent: {{ localPost.content }}</div>
                <div>{{ post.title }}</div>-->
                <hr />
                    
                <div class="box has-margin-bottom-20">
                  <div class="is-size-4 has-text-primary has-margin-bottom-10">
                    <span v-if="post.industry === 'audi-e-tron'">{{ $t('post.input-option-audi-e-tron') }}</span>
                    <span v-else-if="post.industry === 'citroen-berlingo'">{{ $t('post.input-option-citroen-berlingo') }}</span>
                    <span v-else-if="post.industry === 'ds-ds3-crossback-e-tens'">{{ $t('post.input-option-ds-ds3-crossback-e-tense') }}</span>
                    <span v-else-if="post.industry === 'hyundai-ioniq-electric'">{{ $t('post.input-option-hyundai-ioniq-electric') }}</span>
                    <span v-else-if="post.industry === 'hyundai-kona-electric-39-kwh'">{{ $t('post.input-option-hyundai-kona-electric-39-kwh') }}</span>
                    <span v-else-if="post.industry === 'hyundai-kona-electric-64-kwh'">{{ $t('post.input-option-hyundai-kona-electric-64-kwh') }}</span>
                    <span v-else-if="post.industry === 'jaguar-i-pace'">{{ $t('post.input-option-jaguar-i-pace') }}</span>
                    <span v-else-if="post.industry === 'kia-e-niro'">{{ $t('post.input-option-kia-e-niro') }}</span>
                    <span v-else-if="post.industry === 'mg-zs-ev'">{{ $t('post.input-option-mg-zs-ev') }}</span>
                    <span v-else-if="post.industry === 'nissan-e-nv200-combi-visia'">{{ $t('post.input-option-nissan-e-nv200-combi-visia') }}</span>
                    <span v-else-if="post.industry === 'nissan-e-nv200-visia'">{{ $t('post.input-option-nissan-e-nv200-visia') }}</span>
                    <span v-else-if="post.industry === 'nissan-leaf'">{{ $t('post.input-option-nissan-leaf') }}</span>
                    <span v-else-if="post.industry === 'peugeot-e-208'">{{ $t('post.input-option-peugeot-e-208') }}</span>
                    <span v-else-if="post.industry === 'peugeot-partner'">{{ $t('post.input-option-peugeot-partner') }}</span>
                    <span v-else-if="post.industry === 'renault-kangoo-crew-van-ze-33'">{{ $t('post.input-option-renault-kangoo-crew-van-ze-33') }}</span>
                    <span v-else-if="post.industry === 'renault-kangoo-panel-van-ze-33'">{{ $t('post.input-option-renault-kangoo-panel-van-ze-33') }}</span>
                    <span v-else-if="post.industry === 'renault-master-van-ze'">{{ $t('post.input-option-renault-master-van-ze') }}</span>
                    <span v-else-if="post.industry === 'renault-twizy'">{{ $t('post.input-option-renault-twizy') }}</span>
                    <span v-else-if="post.industry === 'renault-zoe'">{{ $t('post.input-option-renault-zoe') }}</span>
                    <span v-else-if="post.industry === 'smart-eq-forfou'">{{ $t('post.input-option-smart-eq-forfou') }}</span>
                    <span v-else-if="post.industry === 'smart-eq-fortwo-cabrio'">{{ $t('post.input-option-smart-eq-fortwo-cabrio') }}</span>
                    <span v-else-if="post.industry === 'smart-eq-fortwo-coupé'">{{ $t('post.input-option-smart-eq-fortwo-coupé') }}</span>
                    <span v-else-if="post.industry === 'tesla-model-3'">{{ $t('post.input-option-tesla-model-3') }}</span>
                    <span v-else-if="post.industry === 'tesla-model-s'">{{ $t('post.input-option-tesla-model-s') }}</span>
                    <span v-else-if="post.industry === 'tesla-model-x'">{{ $t('post.input-option-tesla-model-x') }}</span>
                    <span v-else-if="post.industry === 'volkswagen-e-golf'">{{ $t('post.input-option-volkswagen-e-golf') }}</span>
                    <span v-else-if="post.industry === 'volkswagen-e-up'">{{ $t('post.input-option-volkswagen-e-up') }}</span>  
                    &nbsp;
                    <span class="has-text-grey is-size-7">
                      <i>{{ post.createdOn | formatDate }}</i>
                    </span>
                  </div>

                  <div class="columns">
                    <div v-for="(image) in imagesList" v-bind:key="image" class="column is-multiline">
                      <img v-bind:src=image.imageSetCropped alt="Image to save" class="has-rounded-3" />
                    </div>
                  </div>
                  <article class="message is-warning">
                    <div class="message-body is-size-7">
                      {{ $t('postedit.uneditable') }}
                    </div>
                  </article>
                </div>
                <hr />

                <form @submit.prevent="validateBeforeSubmit">
                  <div>
                    <b-field :label="$t('postedit.input-label-year')">
                      <b-select 
                        v-model="post.year"  
                        :value="post.year" 
                        expanded
                        class="has-margin-bottom-10">
                        <option value="2020">2020</option>
                        <option value="2019">2019</option>
                        <option value="2018">2018</option>
                        <option value="2017">2017</option>
                        <option value="2016">2016</option>
                        <option value="2015">2015</option>
                        <option value="2014">2014</option>
                        <option value="2013">2013</option>
                        <option value="2012">2012</option>
                        <option value="2011">2011</option>
                        <option value="2010">2010</option>
                      </b-select>
                    </b-field>
                    <b>{{ $t('postedit.input-label-odometer') }}</b>
                    <b-field >
                      <b-input  
                        maxlength="10"
                        type="number"
                        v-model.trim="post.odometer"
                        :value="post.odometer" 
                        expanded
                      ></b-input>

                      <b-select v-model="post.odometermetric">
                        <option selected="selected">Miles</option>
                        <option>Kms</option>
                      </b-select>
                    </b-field>

                    <b>{{ $t('post.input-ph-range') }}</b>
                    <b-field
                      :type="{'is-danger': errors.has('range')}"
                      :message="errors.first('range')">
                      <b-input  
                        maxlength="10"
                        type="number"
                        v-model.trim="post.range"
                        :value="post.range" 
                        name="range"
                        expanded
                      ></b-input>
                      <b-select 
                        v-model="post.rangemetric"
                        :value="post.rangemetric">
                        <option selected>Miles</option>
                        <option>Kms</option>
                      </b-select>
                    </b-field>
                    <b>{{ $t('postedit.input-label-battery') }}</b>
                    <b-field
                      :type="{'is-danger': errors.has('battery')}"
                      :message="errors.first('battery')">
                      <b-input  
                        maxlength="10"
                        type="number"
                        v-model.trim="post.battery"
                        :value="post.battery" 
                        name="battery"
                        expanded
                      ></b-input>
                      <p class="control">
                        <span class="button is-static">kWh</span>
                      </p>
                    </b-field>
                    <b>{{ $t('postedit.input-label-charging') }}</b>
                    <b-field
                      :type="{'is-danger': errors.has('charging')}"
                      :message="errors.first('charging')">
                      <b-input  
                        maxlength="10"
                        type="number"
                        v-model.trim="post.charging"
                        :value="post.charging" 
                        name="charging"
                        expanded
                      ></b-input>
                      <p class="control">
                        <span class="button is-static">kW</span>
                      </p>
                    </b-field>
                    <b>{{ $t('postedit.input-label-acceleration') }}</b>
                    <b-field
                      :type="{'is-danger': errors.has('acceleration')}"
                      :message="errors.first('acceleration')">
                      <b-input  
                        maxlength="10"
                        type="number"
                        step=".01"
                        v-model.trim="post.acceleration"
                        :value="post.acceleration" 
                        name="acceleration"
                        expanded
                      ></b-input>
                      <p class="control">
                        <span class="button is-static">Seconds</span>
                      </p>
                    </b-field>
                    <b>{{ $t('postedit.input-label-condition') }}</b>
                    <b-field>
                      <b-select 
                        v-model="post.condition"  
                        :value="post.condition" 
                        v-validate="'required'"
                        name="condition"
                        expanded
                        class="has-margin-bottom-20">
                        <option value="New">{{ $t('post.input-option-new') }}</option>
                        <option value="Used">{{ $t('post.input-option-used') }}</option>
                      </b-select>
                    </b-field>

                    <b-field :label="$t('postedit.input-label-description')">
                      <b-input
                        maxlength="120"
                        type="text"
                        v-model.trim="post.content" 
                        :value="post.content"
                      ></b-input>
                    </b-field>

                    
                    <h5 class="has-margin-top-20">{{ $t('postedit.pricing') }}</h5>
                    <div class="columns">
                      <div class="column is-4">
                        <b-field>
                          <b-select 
                            v-model="post.currency" 
                            :value="post.currency" 
                            expanded>
                            <option value="USD">USD</option>
                            <option value="GBP">GBP</option>
                            <option value="EUR">EUR</option>
                            <option value="AUD">AUD</option>
                            <option value="CAD">CAD</option>
                            <option value="JPY">JPY</option>
                            <option value="BRL">BRL</option>
                            <option value="INR">INR</option>
                            <option value="CNY">CNY</option>
                          </b-select>
                        </b-field>
                      </div>
                      
                      <div class="column is-4">
                        <b-field>
                          <div class="control is-clearfix">
                            <CurrencyInput
                              v-model="post.price"
                              :value="post.price" 
                              :auto-decimal-mode="false"
                              :currency="post.currency"
                              class="input"
                              />
                          </div>
                        </b-field>
                      </div>
                      
                      <div class="column is-4">
                        <b-field>
                          <b-select 
                            v-model="post.pricetype" 
                            :value="post.pricetype" 
                            expanded>
                            <option value="fixed">{{ $t('post.input-option-fixed') }}</option>
                            <option value="negotiable">{{ $t('post.input-option-negotiable') }}</option>
                          </b-select>
                        </b-field>
                      </div>
                    </div>

                    <h5 class="has-margin-top-20">{{ $t('postedit.enquiries') }}</h5>
                    
                    <b>{{ $t('postedit.input-label-email') }}</b>
                    <b-field
                      :type="{'is-danger': errors.has('email')}"
                      :message="errors.first('email')">
                      <b-input
                        maxlength="20"
                        type="email"
                        name="email"
                        v-validate="'required'"
                        v-model.trim="post.email"
                        :value="post.email"
                      ></b-input>
                    </b-field>

                    <b>{{ $t('postedit.input-label-phone') }}</b>
                    <b-field>
                      <b-input
                        maxlength="12"
                        type="text"
                        v-model.trim="post.phone"
                        :value="post.phone"
                      ></b-input>
                    </b-field>
                    <h5 class="has-margin-top-20">{{ $t('post.carslocation') }}</h5>

                    <b>{{ $t('postedit.input-label-country') }}</b>
                    <b-field
                      :type="{'is-danger': errors.has('country')}"
                      :message="errors.first('country')">
                      <b-select 
                        v-model="post.vehiclecountry"  
                        :value="post.vehiclecountry"
                        :placeholder="$t('post.input-ph-vehiclecountry')"
                        v-validate="'required'"
                        name="country"
                        expanded
                        class="has-margin-bottom-20">
                        <option value="USA">{{ $t('post.input-option-vehiclecountry-usa') }}</option>
                        <option value="Great Britian">{{ $t('post.input-option-vehiclecountry-greatbritan') }}</option>
                        <option value="Australia">{{ $t('post.input-option-vehiclecountry-australia') }}</option>
                        <option value="New Zealand">{{ $t('post.input-option-vehiclecountry-newzealand') }}</option>
                        <option value="Canada">{{ $t('post.input-option-vehiclecountry-canada') }}</option>
                        <option value="Ireland">{{ $t('post.input-option-vehiclecountry-ireland') }}</option>
                      </b-select>
                    </b-field>

                    <b>{{ $t('postedit.input-label-location') }}</b>
                    <b-field
                      :type="{'is-danger': errors.has('location')}"
                      :message="errors.first('location')">
                      <b-input  
                        maxlength="10"
                        type="text"
                        v-model.trim="post.vehiclelocation" 
                        :value="post.vehiclelocation"
                        v-validate="'required'"
                        name="location"
                        expanded
                        :placeholder="$t('post.input-ph-vehiclelocation')"
                      ></b-input>
                    </b-field>

                    
                    
                    <hr />
                    <div class="columns is-centered">
                      <div class="column">
                        <button type="submit" class="button is-primary-grad is-rounded is-fullwidth"> {{ $t('postedit.button-publish') }} </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true">
        <div id="spinner"></div>
        <div class="has-padding has-background-light">Loading State:</div>
      </b-loading>
    </section>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  const fb = require("../../firebaseConfig.js");
  import Navigation from '@/components/Navigation';

  import moment from "moment";

  //Image Cropper
  import VueCropper from 'vue-cropperjs';
  //Vendor Image Cropper
  import '@/assets/scss/vendors/cropper/cropper.min.css';
  import vueFilterPrettyBytes from 'vue-filter-pretty-bytes';

  export default {
    data() {
      return {
        post: {
          id: "",
          title: "",
          content: "",
          userName: "",
          userEmail: "",
          createdOn: "",
          industry: "",
          year: "",
          price: "",
          pricetype: "",
          currency: "USD",
          odometer: "",
          odometermetric: "",
          range: "",
          rangemetric: "",
          battery: "",
          charging: "",
          acceleration: "",
          content: "",
          vehiclelocation: "",
          imageUrl1: "",
          imageUrl2: "",
        },

        image:{
          size:'',
          height:'',
          width:''
        },
        showImageModal: false,
        imageError:'',
        imgSrc:'',
        cropImg: '',
        cropImgBlob: '',
        imageFile: null,
        imgSrcCropped: '',

        isLoading: false,
        isFullPage: "",

        imagesList: [],
      }
    },

    components: {
      Navigation,
      VueCropper,
    },
    directives: { 
      vueFilterPrettyBytes
    },

    computed: {
      ...mapState(["userProfile", "currentUser", "posts"/*, "hiddenPosts"*/]),
    },

    beforeMount(){
      //this.isLoading = true;
      this.openLoading()
      this.showPost()
    },

    methods: {
      openLoading() {
        console.log("loading");
        this.isLoading = true;
        setTimeout(() => {
          this.isLoading = false;
        }, 10 * 1000)
        console.log(this.$route.params)
      },

      showPost(){
        let docId = this.$route.params.id;
        console.log("docId = " + docId);
        fb.postsCollection
          .doc(docId)
          .get()
          .then(docs => {
            if(docs.data().userId === this.currentUser.uid){
              this.post.postID = docId
              this.post.content = docs.data().content
              this.post.userName = docs.data().userName
              this.post.userEmail = docs.data().userEmail
              this.post.createdOn = docs.data().createdOn
              this.post.industry = docs.data().industry
              this.post.year = docs.data().year
              this.post.odometer = docs.data().odometer
              this.post.odometermetric = docs.data().odometermetric
              this.post.range = docs.data().range
              this.post.rangemetric = docs.data().rangemetric
              this.post.battery = docs.data().battery
              this.post.charging = docs.data().charging
              this.post.acceleration = docs.data().acceleration
              this.post.condition = docs.data().condition
              this.post.price = docs.data().price
              this.post.pricetype = docs.data().pricetype
              this.post.currency = docs.data().currency
              this.post.email = docs.data().email
              this.post.phone = docs.data().phone
              this.post.vehiclecountry = docs.data().vehiclecountry
              this.post.vehiclelocation = docs.data().vehiclelocation

              this.post.imageUrl1 = docs.data().imageUrl1
              this.post.imageUrl2 = docs.data().imageUrl2
              
              if(this.post.imageUrl1 != null && this.post.imageUrl1 != ""){
                this.imagesList.push({ imageUploadCropped: this.post.imageUrl1, imageSetCropped: this.post.imageUrl1, dbExists: "true" });

              }
              if(this.post.imageUrl2 != null && this.post.imageUrl2 != ""){
                this.imagesList.push({ imageUploadCropped: this.post.imageUrl2, imageSetCropped: this.post.imageUrl2, dbExists: "true" });

              }//this.$set(this.imagesList0, 'imageUploadCropped', this.post.imageUrl1);


              this.isLoading = false;
            } else {
              this.isLoading = false;
              this.$router.push("/posts");
            }
          })
          .catch(err => {
            this.isLoading = false;
            console.log(err);
            this.$router.push("/posts");
          });
      },

      validateBeforeSubmit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.updatePostDetails();
            return;
          }
          this.$toast.open({
            duration: 3000,
            message:  this.$t("postedit.toast-form-invalid"),
            position: "is-bottom",
            type: "is-danger"
          });
          this.scrollTo();
        });
      },

      scrollTo() {
        var element = '#postdetails';
        var duration = 300;
        var options = {
          easing: 'ease-in',
          offset: -80,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        this.$scrollTo(element, duration, options)
      },
      updatePostDetails() {
        this.isLoading = true;
        let docId = this.$route.params.id;
        let content = this.post.content;
        let price = this.post.price;
        let pricetype = this.post.pricetype;
        let currency = this.post.currency;

        let year = this.post.year;
        let odometer = this.post.odometer;
        let odometermetric = this.post.odometermetric;
        let range = this.post.range
        let rangemetric = this.post.rangemetric; 
        let battery = this.post.battery; 
        let charging = this.post.charging; 
        let acceleration = this.post.acceleration; 
        let condition = this.post.condition;
        let phone = this.post.phone;
        let email = this.post.email;
        let vehiclecountry = this.post.vehiclecountry;
        let vechilelocation = this.post.vehiclelocation;
        /*
        if (downloadURL == null && postImageUrl != null) {
          downloadURL = postImageUrl;
        }*/
        //let imageUrl = downloadURL;

        console.log("updatePostDetails() docId: " + docId);

        fb.postsCollection
          .doc(docId)
          .update({ content, phone, email, year, charging, acceleration, condition, odometer, odometermetric, range, rangemetric, battery, vehiclecountry, vechilelocation, price, pricetype, currency })
          .then(() => {
            this.snackbarSuccess();
            this.isLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.snackbarError();
            this.isLoading = false;
          });
      },

      snackbarSuccess() {
        this.$snackbar.open({
          duration: 4000,
          message: this.$t("postedit.snackbar-success"),
          type: "is-primary",
          position: "is-bottom",
          actionText: this.$t("postedit.snackbar-success-action"),
          class: "has-background-info",
          queue: false,
          onAction: () => {
            this.$router.push("/posts");
          }
        });
      },
      snackbarError() {
        this.$snackbar.open({
          duration: 4000,
          message: this.$t("postedit.snackbar-error"),
          type: "is-info",
          position: "is-bottom",
          actionText: this.$t("postedit.snackbar-error-action"),
          queue: false,
          onAction: () => {
            this.$router.push("/posts");
          }
        });
      },
      
      //CleaveJS
      /*
      onInput(event) {
        this.rawValue = event.target._vCleave.getRawValue()
        this.value = event.target._vCleave.getFormattedValue()
      },*/
    },
    filters: {
      formatDate(val) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      },
    }
  }
</script>